(function ($) {

    // Function to change step
    var changeStep = function (stepReference) {
        stepReference = stepReference + "";

        var stepId = stepReference.split("/")[0];
        var anchor = stepReference.split("/").length > 1 ? stepReference.split("/")[1] : "";

        // Validate stepId
        if ($('.wizard-page__step[data-step="' + stepId + '"]').length === 0) return false;

        // Hide all step's, then show the selected one
        $(".wizard-page__step").removeClass("wizard-page__step--active");
        $('.wizard-page__step[data-step="' + stepId + '"]').addClass("wizard-page__step--active");

        // Set active step in step list
        $(".wizard-page__steps li").removeClass("active");
        $('.wizard-page__steps li[data-step="' + stepId + '"]').addClass("active");

        // Update URL
        window.location.hash = stepId + "/" + anchor;

        // Hide/show next/prev buttons
        $(".wizard-page__step-next").hide();
        $(".wizard-page__step-prev").hide();

        if ($('.wizard-page__steps li[data-step="' + stepId + '"]').next().length > 0) {
            $(".wizard-page__step-next").show();
        }
        if ($('.wizard-page__steps li[data-step="' + stepId + '"]').prev().length > 0) {
            $(".wizard-page__step-prev").show();
        }

        // Scroll to step heading (when below)
        if ($("html, body").scrollTop() > $(".wizard-page__steps").offset().top - 50) {
            $("html, body").animate({ scrollTop: $(".wizard-page__steps").offset().top - 50 }, 100);
        }

        return true;
    };

    if ($(".wizard-page").length > 0) {
        // Change active step, when there is a valid step id in url hash
        if (
            window.location.hash !== "" &&
            $('.wizard-page__step[data-step="' + window.location.hash.substr(1).split("/")[0] + '"]').length > 0
        ) {
            changeStep(window.location.hash.substr(1));
        } else {
            // Trigger change step on the first one
            var firstStepId = $(".wizard-page__step").first().data("step");
            changeStep(firstStepId);
        }

        // Click event in step list
        $(".wizard-page__steps li").click(function () {
            changeStep($(this).data("step"));
        });

        // Click event on next/prev buttons
        $(".wizard-page__step-next").click(function() {
            var nextStepId = $(".wizard-page__step--active").next().data("step");
            changeStep(nextStepId);
        });
        $(".wizard-page__step-prev").click(function () {
            var prevStepId = $(".wizard-page__step--active").prev().data("step");
            changeStep(prevStepId);
        });

        // Generate h2/h3 index of each wizard step
        $('.wizard-page__step').each(function () {
            
            var stepId = $(this).data("step");
            var body = $(this).find(".wizard-page__step__body");
            var $stepAnchorLinks = $(this).find('.anchorlinks');

            $(body).find("h2, h3").each(function (index, item) {
                var title = $(item).text().trim();

                var slug = stepId  + "/" + title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
                $(item).attr("id", slug);

                $stepAnchorLinks.append($("<li>").append($("<a>").attr("href", "#" + slug).html(title)));
            });


        });

        $('.wizard-page__step .anchorlinks a').on('click', function (e) {
            e.preventDefault();

            var target = this.hash;
            var $target = $(document.getElementById(target.substr(1)));

            if ($target.length) {
                
                $('html, body').stop().animate({
                    'scrollTop': $target.offset().top
                }, 900, 'swing', function () {
                    window.location.hash = target;
                });
            }
        });

    }

})(jQuery);